import React from 'react';
import  HindiCCA3to52024  from 'views/HindiCCA3to52024';
const BlogNewsroomPage = () => {
return <HindiCCA3to52024/>
};
export default BlogNewsroomPage;